import React from 'react';
import { connect } from 'react-redux';

import { Panel, PanelTop } from 'components/Panel';
import { Table, Td } from 'components/Table';
import { dateRows } from 'components/util';
import ResultLink from 'components/ResultLink';

const ResultsX = ({ results }) => (
    <Panel border>
        <PanelTop>
            <h2>Results</h2>
        </PanelTop>
        <div>
            <Table compact topborder>
                <tbody>
                    {dateRows(results, 6, (result, longDate, shortestDate, rowClassName) => (
                        <ResultsRow key={result.mid} result={result} shortestDate={shortestDate} rowClassName={rowClassName} />
                    ))}
                </tbody>
            </Table>
        </div>
    </Panel>
);

const Results = connect(state => ({
    results: state.data.results
}))(ResultsX);

export default Results;

const ResultsRow = ({ result, rowClassName, shortestDate }) => {
    let opposition = result.opposition;
    if (result.url) {
        opposition = (
            <a href={result.url} target="_new">
                {opposition}
            </a>
        );
    }
    return (
        <tr className={rowClassName}>
            <Td min="6">{shortestDate}</Td>
            <Td min="6">{result.team} v</Td>
            <Td ellipsis="6" left>
                {opposition}
            </Td>
            <Td min="6" left>
                <ResultLink fixture={result} rolloverDirection="left" />
            </Td>
        </tr>
    );
};



// WEBPACK FOOTER //
// ./src/views/home/Results.jsx